import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const DesktopOnly = styled.div`
  ${media.mediumDown`
    display:none;
  `}
`;

export const MediumUp = styled.div`
  ${media.smallOnly`
    display:none;
  `}
`;

export const MobileOnly = styled.div`
  ${media.mediumUp`
    display: none;
  `}
`;
